import './i18n-config';

import { withAuthenticationRequired } from '@auth0/auth0-react';
import NiceModal from '@ebay/nice-modal-react';
import { ReactQueryDevtools } from '@tanstack/react-query-devtools';
import { LoadingSpinner } from 'components/LoadingSpinner';
import { useEffect, useState } from 'react';
import { Navigate, Route } from 'react-router-dom';

import { SentryRoutes } from './configs/sentry';
import i18n from './i18n-config';
import ErrorPage from './layout/errors/ErrorPage';
import AppLandingPage from './pages/AppLandingPage';
import Page403 from './pages/Page403';
import Page404 from './pages/Page404';
import UserPasswordOverviewPage from './pages/user/UserPasswordOverviewPage';
import VersionHint from './pages/VersionHint';

const ProtectedAppLandingPage = withAuthenticationRequired(AppLandingPage);

export default function App() {
  // https://stackoverflow.com/questions/78576883/react-i18next-uncaught-error-a-component-suspended-while-responding-to-synchron
  const [i18nReady, setI18nReady] = useState(i18n.isInitialized);
  useEffect(() => {
    if (!i18n.isInitialized) {
      const onInit = () => setI18nReady(true);
      i18n.on('initialized', onInit);
      return () => i18n.off('initialized', onInit);
    }
  }, []);
  if (!i18nReady) {
    return <LoadingSpinner />;
  }

  return (
    <>
      <Router />
      <ReactQueryDevtools initialIsOpen />
    </>
  );
}

function Router() {
  return (
    <div className="App" style={{ height: '1px' }}>
      <SentryRoutes>
        <Route index element={<Navigate to="/app" />} />
        <Route path="/" element={<Navigate to="/app" />} />
        <Route path="/login" element={<Navigate to="/app" />} />
        {/* ALL ROUTES THAT REQUIRE AUTHENTICATION, ARE NESTED INSIDE /app*/}+
        <Route
          path="app/*"
          element={
            <NiceModal.Provider>
              <ProtectedAppLandingPage />
            </NiceModal.Provider>
          }
        />
        <Route path="accept-invitation" element={<UserPasswordOverviewPage />} />
        <Route path="version" element={<VersionHint />} />
        <Route path="error" element={<ErrorPage />} />
        <Route path="403" element={<Page403 />} />
        <Route path="404" element={<Page404 />} />
        <Route path="*" element={<Page404 />} />
      </SentryRoutes>
    </div>
  );
}
